import { CALL_API } from '../../../common/middleware/api';

export const SALES_ANALYTICS_REQUEST = 'SALES_ANALYTICS_REQUEST';
export const SALES_ANALYTICS_SUCCESS = 'SALES_ANALYTICS_SUCCESS';
export const SALES_ANALYTICS_FAILURE = 'SALES_ANALYTICS_FAILURE';

export const loadSalesAnalyticsData = (item, options) => ({
	[CALL_API]: {
		types: [SALES_ANALYTICS_REQUEST, SALES_ANALYTICS_SUCCESS, SALES_ANALYTICS_FAILURE],
		endpoint: `api/analytics/sales/${item}`,
		method: 'POST',
		request: options
	},
	item
});